import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthContext = createContext();
export { AuthContext }; // <-- LIPSEA!

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const syncOnboardingAnswers = async () => {
    try {
      const rawOnboardingAnswers = localStorage.getItem('onboardingAnswers');
      if (!rawOnboardingAnswers) return;

      const onboardingAnswers = JSON.parse(rawOnboardingAnswers);
      if (!onboardingAnswers || typeof onboardingAnswers !== 'object') return;

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/onboarding-answers`,
        onboardingAnswers,
        {
          withCredentials: true,
          timeout: 5000,
        }
      );

      if (response.status >= 200 && response.status < 300) {
        localStorage.removeItem('onboardingAnswers');
      }
    } catch (err) {
      // Non-blocking: auth should continue even if onboarding sync fails.
    }
  };

const checkAuth = async () => {
  setLoading(true);
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/user`, {
      withCredentials: true,
      timeout: 5000
    });
    const userData = res.data;
    setUser(userData);

    await syncOnboardingAnswers();

    // 👇 Aplică tema global (fără context circular)
    if (typeof userData.dark_mode === 'boolean') {
      if (userData.dark_mode) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    }

    return userData;

  } catch (err) {
    console.log('Auth check failed:', err.message);
    setUser(null);
    document.documentElement.classList.remove('dark-mode'); // fallback safe
    return null;
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, checkAuth, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
